import { render, staticRenderFns } from "./AutoPriceListAddEdit.vue?vue&type=template&id=634e2f8c&scoped=true&"
import script from "./AutoPriceListAddEdit.vue?vue&type=script&lang=js&"
export * from "./AutoPriceListAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./AutoPriceListAddEdit.vue?vue&type=style&index=0&id=634e2f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634e2f8c",
  null
  
)

export default component.exports